import moment from 'moment';
import qs from 'query-string';

export const getGoogleCalendarLink = ({
  date = '',
  location = '',
  title = '',
}) => {
  const baseUrl = 'https://www.google.com/calendar/render';
  const misc = 'action=TEMPLATE&details=&sprop=&sprop=name:';
  const format = 'YYYYMMDD';
  const startDateFormatted = date ? moment(date).format(format) : '';
  const endDateFormatted = date ? moment(date).add(1, 'd').format(format) : '';
  const params = {
    location,
    text: title,
  };

  if (date) params.dates = `${startDateFormatted}/${endDateFormatted}`;

  const queryString = qs.stringify(params);

  return `${baseUrl}?${misc}&${queryString}`;
};



// WEBPACK FOOTER //
// ./src/utils/calendarLinks.js